import type { StateCreator } from 'zustand'

import type { OrganizationsStore } from '../types'

import type { OrganizationsDataSlice } from './organizations-data.slice.type'

export const createOrganizationsDataSlice: StateCreator<
  OrganizationsStore,
  [['zustand/immer', never]],
  [],
  OrganizationsDataSlice
> = () => ({
  organizations: [],
  loading: false,
  error: null,
})
